import commonPostTypeConfig from '../../common/postTypes/apiKey'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'apiKey',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
